import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk'

import { AppReducer } from '../reducers/AppReducer';

export const createAppStore = () => {
  return createStore(
		AppReducer,
		applyMiddleware(
			thunkMiddleware
		)
	);
};



// WEBPACK FOOTER //
// ./state/stores/AppStore.js